import React, { useState, useEffect } from "react";
import {Container,Row,Col} from 'react-bootstrap'
import LowerBarCart from './LowerBarCart'
import LowerBarCategory from './LowerBarCategory'
import LowerBarSearch from './LowerBarSearch'
const LowerBar = () => {
    const [stickyClass, setStickyClass] = useState("");
    useEffect(() => {
        window.addEventListener("scroll", stickNavbar);
        return () => window.removeEventListener("scroll", stickNavbar);
      },[])

      const stickNavbar = () => {
        if (window !== undefined) {
          let windowHeight = window.scrollY;
          // window height changed for the demo
          windowHeight > 150 ? setStickyClass("isSticky") : setStickyClass("");
        }
      };
    return (
        <>
            <Container fluid className={`${stickyClass}`}>
                <Row>
                    <Col sm>
                        <div className="middle">
                           <LowerBarCategory/>
                        </div>
                    </Col>
                    <Col sm>
                        <div className="middle">
                        <LowerBarSearch/>
                        </div>
                    </Col>
                    <Col sm>
                        <div className="middle">
                        <LowerBarCart/>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default LowerBar